/**
 * Cookie Consent Configuration
 *
 * GDPR-compliant consent management for tracking services.
 * Categories:
 * - Necessary: Always on (Firebase auth, essential functionality)
 * - Analytics: Google Analytics, Sentry error tracking
 * - Marketing: Meta Pixel, Reddit Pixel
 */

export const CONSENT_VERSION = "1.0";
export const CONSENT_STORAGE_KEY = "darvin_cookie_consent";

export interface ConsentPreferences {
  necessary: true; // Always true (Firebase auth)
  analytics: boolean; // Google Analytics, Sentry
  marketing: boolean; // Meta Pixel, Reddit Pixel
  consentTimestamp: string; // ISO timestamp
  consentVersion: string; // For re-consent on policy changes
}

export const defaultConsent: ConsentPreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
  consentTimestamp: "",
  consentVersion: CONSENT_VERSION,
};

/**
 * Cookie categories with descriptions for the preferences modal
 */
export const COOKIE_CATEGORIES = {
  necessary: {
    id: "necessary",
    label: "Necessary",
    description:
      "Required for authentication and core functionality. Cannot be disabled.",
    services: ["Firebase Authentication"],
    required: true,
  },
  analytics: {
    id: "analytics",
    label: "Analytics",
    description:
      "Help us understand how you use Darvin to improve the experience.",
    services: ["Google Analytics", "Sentry Error Tracking"],
    required: false,
  },
  marketing: {
    id: "marketing",
    label: "Marketing",
    description: "Used to measure the effectiveness of our advertising.",
    services: ["Meta Pixel", "Reddit Pixel"],
    required: false,
  },
} as const;
